export default __webpack_public_path__ + "static/media/Background_00212.c26a13ca.png";